import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import CustomerMainPart from './CustomerMainPart';
import CustomerHeader from './CustomerHeader';
import CustomerSidebar from './CustomerSidebar';
import CustomerContentPart from './CustomerContentPart';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomerProfileService } from '@/services/CustomerServices';
import { setUserData } from '@/store/actions';

const CustomerLayout = () => {
  const dispatch = useDispatch();
  const { adminSideDrawer, generalSetting } = useSelector((s) => s?.GeneralSetting);

  // this is whatever you store in Auth.userData (may be '' initially)
  const customer = useSelector((s) => s.Auth.userData);

  // detect if we’re in “customer” session
  const hasCustomerToken =
    !!localStorage.getItem('customer_jwt') || !!localStorage.getItem('customerToken');

  useEffect(() => {
    if (!hasCustomerToken) return;

    let ignore = false;

    const refresh = () =>
      dispatch(getCustomerProfileService())
        .then((res) => {
          if (ignore) return;
          const data = res?.data?.data;
          if (data) {
            // normalize to the shape your reducer expects
            dispatch(setUserData({ data: { data } }));
          }
        })
        .catch(() => {});

    // 1) Always fetch once on mount (so admin-side changes are reflected)
    refresh();

    // 2) Also refresh when the tab is focused or becomes visible
    const onFocus = () => refresh();
    const onVis = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVis);

    return () => {
      ignore = true;
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [dispatch, hasCustomerToken]);

  return (
    <CustomerMainPart adminSideDrawer={adminSideDrawer}>
      <CustomerHeader
        title={generalSetting?.company_name}
        faviconIcon={generalSetting?.fav_icon}
      />
      {adminSideDrawer && <CustomerSidebar />}
      <CustomerContentPart>
        <Outlet />
      </CustomerContentPart>
    </CustomerMainPart>
  );
};

export default CustomerLayout;
